import dayjs from 'dayjs';
// modules
import { WhatsNewIndicatorStatus, WhatsNewIndicatorConfig } from 'modules/App';
import { LStorage } from 'modules/Storage';

export const updateWhatsNewIndicatorStatusInLS = () => {
  const whatsNewIndicatorStatus: WhatsNewIndicatorStatus | null =
    LStorage.getItem('WHATS_NEW_INDICATOR_STATUS');
  if (!whatsNewIndicatorStatus) {
    return;
  }
  const endOfDay = dayjs().endOf('day');
  let { count, expiry } = whatsNewIndicatorStatus;
  count = Number.isNaN(count) ? 0 : count;
  count += 1;
  expiry = endOfDay.toJSON();
  LStorage.setItem('WHATS_NEW_INDICATOR_STATUS', {
    ...whatsNewIndicatorStatus,
    count,
    expiry,
  });
};

export const isCleanupRequired = (
  whatsNewIndicatorConfig: WhatsNewIndicatorConfig,
  whatsNewIndicatorStatus: WhatsNewIndicatorStatus | null,
) =>
  whatsNewIndicatorConfig.type !== whatsNewIndicatorStatus?.type ||
  whatsNewIndicatorConfig.version !== whatsNewIndicatorStatus?.version;

export const cleanupAndSetDefaultState = (
  whatsNewIndicatorConfig: WhatsNewIndicatorConfig,
) => {
  const whatsNewIndicatorStatus: WhatsNewIndicatorStatus | null =
    LStorage.getItem('WHATS_NEW_INDICATOR_STATUS');
  // If type is changed or new version of same type is available, cleanup the local storage item
  const cleanupRequired = isCleanupRequired(
    whatsNewIndicatorConfig,
    whatsNewIndicatorStatus,
  );
  // If cleanup is done or local storage item was not present, set the new default state
  const defaultRequired = cleanupRequired || !whatsNewIndicatorStatus;

  if (cleanupRequired) {
    LStorage.removeItem('WHATS_NEW_INDICATOR_STATUS');
  }

  if (defaultRequired) {
    LStorage.setItem('WHATS_NEW_INDICATOR_STATUS', {
      type: whatsNewIndicatorConfig.type,
      version: whatsNewIndicatorConfig.version,
      count: 0,
      expiry: dayjs()
        .endOf('day')
        .toJSON(),
    });
  }
};
